import { Injectable } from '@angular/core';
import { IFundFamily } from '@common/models/IFundFamily';
import { ApiService } from '@app/core/services/api.service';
import { Observable, of } from 'rxjs';
import { SystemPropertyValue } from '@common/models/ISystemProperty';
import { LocalStorageKey } from '../enums/local-storage-key.enum';

@Injectable({
    providedIn: 'root'
})
export class SystemPropertiesService {
    constructor(private apiService: ApiService) {

    }

    public getAll(): Observable<IFundFamily[]> {
        return this.apiService.get('SystemProperty');
    }

    public getByKey<T extends SystemPropertyValue>(key: string, defaultValue?: T): Observable<T> {
        if (localStorage[LocalStorageKey.systemPropertyCache] !==null) {
            const systemData = JSON.parse(localStorage[LocalStorageKey.systemPropertyCache] || '[]');
            return of(systemData.filter(prop => prop.key === key)[0]?.value ?? defaultValue)
        }
    }
}
